// Common
import { useMemo } from 'react'

// Hooks
import useWindowSize from './useWindowSize'

export default function useMobile(): boolean{
	const width = useWindowSize()
	const mobile = useMemo(() => {
		return width <= 800
	}, [width])

	return mobile
}
